import { Form, Input, Divider, Button } from "antd";
import "./index.scss";
import {
    PlusOutlined,
    MinusCircleOutlined
} from "@ant-design/icons";
const { TextArea } = Input;
import { CKEditor } from "ckeditor4-react";

const BannerForm = ({ lang, onChangeContentValue, content, id = '', isBanner = true }) => {
    console.log(content.content_vi);
    return (
        <>
            <Form.Item label="Title" name={`title_${lang}`}>
                <TextArea autoSize={{ minRows: 1, maxRows: 5 }} />
            </Form.Item>
            <Form.Item label="Content" name={`content_${lang}`}>
                {content?.content_vi || content?.content_kr || content?.content_en || !id ? (
                    <CKEditor
                        initData={content['content_' + lang]}
                        onChange={(e) => {
                            onChangeContentValue({
                                name: "content_" + lang,
                                content: e.editor.getData(),
                            });
                        }}
                        config={{
                            toolbarGroups: [
                                {
                                    name: "document",
                                    groups: ["mode", "document", "doctools"],
                                },
                                {
                                    name: "clipboard",
                                    groups: ["clipboard", "undo"],
                                },
                                {
                                    name: "editing",
                                    groups: [
                                        "find",
                                        "selection",
                                        "spellchecker",
                                        "editing",
                                    ],
                                },
                                { name: "forms", groups: ["forms"] },
                                {
                                    name: "basicstyles",
                                    groups: ["basicstyles", "cleanup"],
                                },
                                {
                                    name: "paragraph",
                                    groups: [
                                        "list",
                                        "indent",
                                        "blocks",
                                        "align",
                                        "bidi",
                                        "paragraph",
                                    ],
                                },
                                { name: "links", groups: ["links"] },
                                { name: "insert", groups: ["insert"] },
                                { name: "styles", groups: ["styles"] },
                                { name: "colors", groups: ["colors"] },
                                { name: "tools", groups: ["tools"] },
                                { name: "others", groups: ["others"] },
                                { name: "about", groups: ["about"] },
                            ],
                            filebrowserBrowseUrl: '/ckfinder/browser',
                            filebrowserImageBrowseUrl: "/ckfinder/browser?type=Images&token=123",
                            filebrowserFlashBrowseUrl: "/ckfinder/browser?type=Flash&token=123",
                            filebrowserUploadUrl: "/ckfinder/connector?command=QuickUpload&type=Files",
                            filebrowserImageUploadUrl: "/ckfinder/connector?command=QuickUpload&type=Images",
                            filebrowserFlashUploadUrl: "/ckfinder/connector?command=QuickUpload&type=Flash",
                            height: 300,
                        }}
                    />
                ) : (
                    <></>
                )}

            </Form.Item>
            {!isBanner ?
            <Form.List name="fields">
                {(fields, { add, remove }) => {
                    return (
                        <div>
                            {fields.map((field, index) => (
                                <div key={field.key}>
                                    <Divider>Address Form {index + 1}</Divider>
                                    <Form.Item
                                        name={[index, "title_" + lang]}
                                        label="Address"
                                    >
                                        <Input/>
                                    </Form.Item>
                                    <Form.Item
                                        name={[index, "content_" + lang]}
                                        label="Content"
                                    >
                                        <TextArea size={{minRows: 5}} />
                                    </Form.Item>
                                    {fields.length > 1 ? (
                                        <Button
                                            type="danger"
                                            className="dynamic-delete-button"
                                            onClick={() => remove(field.name)}
                                            icon={<MinusCircleOutlined />}
                                        >
                                            Remove Above Address Form
                                        </Button>
                                    ) : null}
                                </div>
                            ))}
                            <Divider />
                            <Form.Item>
                                <Button
                                    type="dashed"
                                    onClick={() => add()}
                                    style={{ width: "60%" }}
                                >
                                    <PlusOutlined /> Add Address
                                </Button>
                            </Form.Item>
                        </div>
                    );
                }}
            </Form.List>
            :
            <></>
            }
        </>
    );
};
export default BannerForm;
